/** import package [start] */
import { useEffect, useState, FC } from 'react';
import { useParams } from 'react-router';
/** import package [end] */

/** import custom dependency [start] */
import NetworkDetails from './NetworkDetails';
/** import custom dependency [end] */

/**
 * main page component of network details page
 * @returns JSX.Element
 */

const NetworkDetailsPage: FC = () => {
    const [networkId, setNetworkId] = useState<string | undefined>();

    // set network Id
    const { id } = useParams<{ id: string }>();
    useEffect(() => {
        setNetworkId(() => id);
    }, [id]);

    return <>{networkId && <NetworkDetails id={networkId} />}</>;
};

export default NetworkDetailsPage;